import useRoleNavigate from '@brands/hooks/useRoleNavigate';
import React, { useCallback } from 'react';

import modalClose from '../../../assets/icons/close.svg';
import styles from './dashboardModal.module.scss';

const SubmitCEConfirmationModal = (): JSX.Element => {
  const roleNavigate = useRoleNavigate();
  const goToDashboard = useCallback(() => {
    roleNavigate('/dashboard');
  }, [roleNavigate]);
  return (
    <div className={styles.modalBackground} onClick={() => goToDashboard()}>
      <div
        className={`${styles.modalContainer} ${styles.submitConfirmationModal} fs-unmask`}
        onClick={(e) => e.stopPropagation()}
      >
        <button
          type="button"
          className={styles.modalClose}
          style={{ backgroundImage: `url(${modalClose})` }}
          aria-label="Close modal"
          onClick={() => goToDashboard()}
        />
        <div className={styles.body}>

          <p className={styles.CEConfirmThankYou}>Thank you!</p>
          <p className={styles.CEConfirmTextContent}>
            Your case has been submitted. A licensed dentist will review it and respond within 24 hours.
          </p>
        </div>
      </div>
    </div>
  );
};
export default SubmitCEConfirmationModal;
